import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app-settings';
import { TSystemData } from 'src/app/models/system-data';
import { ApiRequestService } from 'src/app/services/api-request.service';
import { EditSystemService } from 'src/app/services/edit-system.service';
import { LanguageService } from 'src/app/services/language.service';
import { SystemsService } from 'src/app/services/systems.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { WebSocketService } from 'src/app/services/websocket.service';

@Component({
  selector: 'app-cp-system-list-item',
  templateUrl: './cp-system-list-item.component.html',
  styleUrls: ['./cp-system-list-item.component.scss'],
})
export class CpSystemListItemComponent implements OnInit {
  @Input() systemItem: TSystemData = null;
  @Input() showInstaller = false;
  @Input() showAddress = false;
  @Input() showBorder = true;
  @Input() showArrow = true;
  @Input() showBookmark = true;
  @Input() isClickable = true;
  @Input() showDelete = false;
  public installerNameText = '';
  public isBookmarked = false;
  public canDelete = AppSettings.canDeleteSystemFromList;

  constructor(
    public lang: LanguageService,
    private router: Router,
    private ss: SystemsService,
    private rs: ApiRequestService,
    private toaster: ToasterService,
    private ws: WebSocketService,
    private es: EditSystemService
  ) {}

  ngOnInit(): void {
    this.rebuildInstallerName();
    this.checkIfBookmarked();
    this.canDelete = this.canDelete && this.isClickable && this.showDelete;
  }

  public gotoSystem() {
    if (!this.isClickable) {
      return;
    }
    this.ss.setCurrentSystem(this.systemItem);
    this.ws.websockInit();
    this.router.navigate(['/home']);
  }

  private checkIfBookmarked() {
    this.isBookmarked = this.ss.systemBookmarks.includes(this.systemItem.id);
  }

  public toggleBookmark() {
    const that = this;
    let added = true;
    let url = '/bookmark/add';
    if (this.ss.systemBookmarks.includes(this.systemItem.id)) {
      this.ss.systemBookmarks.splice(this.ss.systemBookmarks.indexOf(this.systemItem.id), 1);
      url = '/bookmark/remove';
      added = false;
    } else {
      this.ss.systemBookmarks.push(this.systemItem.id);
    }
    this.checkIfBookmarked();
    const systemIdToUse = this.systemItem.id;
    this.rs.post(url, { id: this.systemItem.id }, true).subscribe(
      (result) => {
        if (!result.success) {
          that.toaster.postError(result.error);
          that.revertBookmark(added, systemIdToUse);
        }
      },
      (error) => {
        that.toaster.postError(that.lang.get('auth.errors.serverSideError'));
        that.revertBookmark(added, systemIdToUse);
      }
    );
  }

  private revertBookmark(wasAdded: boolean, systemId: number) {
    if (wasAdded) {
      this.ss.systemBookmarks.splice(this.ss.systemBookmarks.indexOf(systemId), 1);
    } else {
      this.ss.systemBookmarks.push(systemId);
    }
    this.checkIfBookmarked();
  }

  public rebuildInstallerName() {
    if ( this.systemItem.assistedById ) {
      this.installerNameText = this.systemItem.assistedByEmail + ' [' + this.lang.get('users.labels.isAssisting') + ']';
    } else if (this.systemItem.installerId !== 0) {
      this.installerNameText = this.systemItem.installerName + ' (' + this.systemItem.installerEmail + ')';
    } else {
      this.installerNameText = this.lang.get('systems.labels.none');
    }
  }

  public deleteSystem() {
    this.es.deleteSystem(this.systemItem.id);
  }
}
